import { clsx } from "clsx";
import { type Ref, type InputHTMLAttributes } from "react";

export interface PlainInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export default function PlainInput({ invalid, ...props }: PlainInputProps) {
  const className = clsx(
    `
      relative block w-full appearance-none rounded-md border border-solid
      bg-white bg-clip-padding px-3 py-2 leading-normal font-normal text-black
      transition
      focus:shadow focus:outline-0
      disabled:bg-gray-300
      dark:bg-neutral-800 dark:text-white dark:disabled:bg-neutral-700
    `,
    {
      "border-red-300 shadow-rose-700/25": invalid,
      "border-zinc-200 focus:border-blue-300 dark:border-zinc-600": !invalid,
    },
  );
  return <input {...props} className={className} />;
}
